import { CircleCheck } from "lucide-react";
const benefits = ["Pusat informasi terkini seputar dunia ojek online di seluruh Indonesia.", "Layanan laporan lapangan untuk keamanan dan kenyamanan rekan driver.", "Komunitas solid untuk berbagi pengalaman dan mempererat silaturahmi.", "Wadah aspirasi resmi untuk menyuarakan hak-hak pengemudi online.", "Update real-time mengenai info razia dan kondisi jalanan terbaru."];
export default function HeroPojokOjol() {
  return <section data-section-id="259535" id="hero-pojok-ojol" className="py-24 bg-background text-foreground overflow-hidden">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Content Column */}
          <div className="order-2 lg:order-1 flex flex-col justify-center">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight mb-10">
              POJOK OJOL.<br />
              <span className="text-primary">Solidaritas Driver.</span>
            </h2>
            
            <ul className="space-y-6">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mt-0.5">
                    <CircleCheck className="w-6 h-6 text-primary" />
                  </div>
                  <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed pt-2">
                    {benefit}
                  </p>
                </li>)}
            </ul>
          </div>

          {/* Image Column */}
          <div className="order-1 lg:order-2 relative">
            {/* Decorative Accent */}
            <div className="absolute -inset-4 bg-primary/20 blur-3xl rounded-lg opacity-50 pointer-events-none"></div>
            
            <div className="relative rounded-lg overflow-hidden border border-border/50 shadow-xl shadow-black/5 bg-card">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_community_map_info.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_community_map_info.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_community_map_info.png-wvc-sizes" alt="Driver ojek online berkumpul memantau informasi jalanan" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto" loading="lazy" />
              {/* Glass Overlay Effect */}
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 pointer-events-none rounded-lg"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}